import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["shareButton", "copyButton", "message", "url"]

  connect() {
    this._configureButtons()
  }

  disconnect() {
    this._cleanup()
  }

  async share() {
    try {
      await navigator.share({
        title: this.element.dataset.shareTitle,
        text: this._buildShareText(),
        url: this.urlTarget.textContent.trim()
      })
    } catch (error) {
      if (error.name !== "AbortError") {
        this._fallbackCopy()
      }
    }
  }

  async copy() {
    try {
      const text = this._buildShareText() + "\n" + this.urlTarget.textContent.trim()
      await navigator.clipboard.writeText(text)
      this._showToast()
    } catch (error) {
      this._selectFallback()
    }
  }

  _configureButtons() {
    const canShare = typeof navigator.share === "function"
    if (this.hasShareButtonTarget) {
      this.shareButtonTarget.hidden = !canShare
    }
    if (this.hasCopyButtonTarget) {
      this.copyButtonTarget.hidden = false
    }
  }

  _buildShareText() {
    const base = this.element.dataset.shareMessage || ""
    const personal = this.hasMessageTarget ? this.messageTarget.value.trim() : ""
    return personal ? `${base}\n\n${personal}` : base
  }

  _fallbackCopy() {
    this.copy()
  }

  _selectFallback() {
    const url = this.urlTarget
    if (url.select) url.select()
  }

  _showToast() {
    const toast = document.createElement("div")
    toast.className = "fixed top-4 right-4 z-50 max-w-sm toast-enter"
    toast.setAttribute("role", "status")
    toast.setAttribute("data-controller", "auto-dismiss")
    toast.setAttribute("data-auto-dismiss-delay-value", "3000")

    const inner = document.createElement("div")
    inner.className = "toast-glass toast-notice flex items-center gap-3 px-4 py-3"

    const text = document.createElement("p")
    text.className = "text-sm font-medium text-primary"
    text.textContent = this.element.dataset.copiedMessage || "Lien copié"

    inner.appendChild(text)
    toast.appendChild(inner)
    document.body.appendChild(toast)
  }

  _cleanup() {
    // No persistent listeners to remove
  }
}
